import React from 'react';
import { BookCheck, Clock, Compass, HardDrive, Layers, BookOpen } from "lucide-react";

// Mock activity data
const recentActivity = [
  { id: 1, action: "Completed lesson", target: "Data Visualization Techniques", time: "Today, 2:34 PM", icon: BookCheck, color: "#22C55E" },
  { id: 2, action: "Started course", target: "Advanced SEO Strategies", time: "Today, 11:15 AM", icon: BookOpen, color: "#3B82F6" },
  { id: 3, action: "Used tool", target: "AEO Analyzer", time: "Yesterday, 4:22 PM", icon: Compass, color: "#8B5CF6" },
  { id: 4, action: "Saved resource", target: "Content Strategy Template", time: "Yesterday, 1:50 PM", icon: HardDrive, color: "#F59E0B" },
  { id: 5, action: "Generated content", target: "Blog Post Introduction", time: "Jul 14, 2023, 10:30 AM", icon: Layers, color: "#EC4899" },
  { id: 6, action: "Logged in", target: "New device detected", time: "Jul 14, 2023, 9:45 AM", icon: Clock, color: "#0EA5E9" },
];

export function AccountActivity() {
  return (
    <div className="overflow-hidden rounded-2xl border border-white/[0.07] bg-og01-card p-6">
      <div className="mb-5">
        <h3 className="font-heading text-[20px] text-og01-text">Recent Activity</h3>
        <p className="mt-1 text-[13px] text-og01-text-secondary">Your activity across the platform in the last 30 days</p>
      </div>
      <div>
        {recentActivity.map((activity) => {
          const Icon = activity.icon;
          return (
            <div key={activity.id} className="flex gap-3.5 border-t border-white/[0.07] py-[15px] first:border-t-0 first:pt-0">
              <div className="grid h-9 w-9 flex-none place-items-center rounded-[10px]" style={{ background: `color-mix(in srgb, ${activity.color} 16%, transparent)` }}>
                <Icon className="h-[18px] w-[18px]" style={{ color: activity.color }} />
              </div>
              <div>
                <div className="text-sm font-semibold text-og01-text">{activity.action}</div>
                <div className="mt-px text-[13px] text-og01-text-secondary">{activity.target}</div>
                <div className="mt-0.5 text-xs text-og01-text-muted">{activity.time}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
